import React, { useState, useCallback } from 'react';
import i18next from 'i18next';
import { TableColumnRow, TableColumnCell } from '../TableColumn';
import { ButtonContent, ButtonInlineBold } from '../Button';

interface PhoneNumberProps {
  phoneNumber: string;
}

const PhoneNumber = ({ phoneNumber }: PhoneNumberProps) => {
  const [visible, setVisible] = useState(false);

  const onClick = useCallback(() => !visible && setVisible(true), [visible]);

  return (
    <TableColumnRow>
      <TableColumnCell>{i18next.t('other.phoneNumber')}</TableColumnCell>
      <TableColumnCell>
        {visible ? (
          <ButtonInlineBold
            as="a"
            href={`tel:${phoneNumber}`}
            title={i18next.t('other.callPhoneNumber', { phoneNumber }) || ''}
          >
            <ButtonContent>{phoneNumber}</ButtonContent>
          </ButtonInlineBold>
        ) : (
          <ButtonInlineBold onClick={onClick} title={i18next.t('other.showPhoneNumber') || ''}>
            <ButtonContent>{i18next.t('other.showPhoneNumber')}</ButtonContent>
          </ButtonInlineBold>
        )}
      </TableColumnCell>
    </TableColumnRow>
  );
};

export default PhoneNumber;
